import extra from "./tdahKidsI18n-extra";
const tdahKidsTranslations = {
  fr: {
    // Exercise titles & subtitles
    superpowers_title: "Mes Super-Pouvoirs Cosmiques",
    superpowers_subtitle: "Decouvre tes forces secretes d'astronaute !",
    safety_bubble_title: "Ma Bulle Spatiale",
    safety_bubble_subtitle: "Cree ton bouclier de protection personnalise",
    relaxation_title: "Retour en Orbite",
    relaxation_subtitle: "Relaxation musculaire pour vider ton moteur",
    agitation_radar_title: "Mon Radar Galactique",
    agitation_radar_subtitle: "Detecte et comprends tes sensations",
    recharge_title: "Station de Recharge",
    recharge_subtitle: "Trouve tes activites pour recharger tes batteries",
    turbo_brain_title: "Mon Vaisseau Turbo",
    turbo_brain_subtitle: "Comprends ton cerveau turbo et son frein",
    mission_title: "Mission Spatiale",
    mission_subtitle: "Releve des defis de self-control !",
    superhero_day_title: "Ma Journee d'Astronaute",
    superhero_day_subtitle: "Suis ton energie tout au long de la journee",
    victories_title: "Mes Etoiles de Victoire",
    victories_subtitle: "Celebre tes reussites, meme les plus petites !",
    therapist_questions_title: "Message au Centre de Controle",
    therapist_questions_subtitle: "Note tes questions pour ton therapeute",
    // Common
    save: "Sauvegarder",
    add: "Ajouter",
    other: "Autre chose...",
    history: "Historique",
    no_history: "Aucun historique",
    exercise_not_found: "Exercice non trouve",
    saved_success: "Bravo, exercice sauvegarde !",
    save_error: "Erreur lors de la sauvegarde",
    notes: "Notes",
    notes_placeholder: "Observations de la journee...",
    // Superpowers
    sp_known: "Mes super-pouvoirs que je connais deja",
    sp_custom: "Quels sont mes autres super-pouvoirs ?",
    sp_placeholder: "Super-pouvoir",
    sp_save: "Sauvegarder mes super-pouvoirs",
    sp_preset_1: "Je remarque des details que les autres ne voient pas",
    sp_preset_2: "J'ai plein d'idees pour jouer",
    sp_preset_3: "Je comprends les autres quand ils ne vont pas bien",
    sp_preset_4: "Je suis tres concentre quand ca me passionne",
    // Safety Bubble
    bubble_color: "Quelle couleur a ma bulle ?",
    bubble_color_hint: "Ex: bleu calme, vert apaisant, rose doux...",
    bubble_color_ph: "Couleur de ma bulle...",
    bubble_shape: "Quelle forme a-t-elle ?",
    bubble_shape_hint: "Ronde, carree, comme un bouclier...",
    bubble_shape_ph: "Forme...",
    bubble_texture: "Quelle est sa texture ?",
    bubble_texture_hint: "Douce, solide, brillante...",
    bubble_texture_ph: "Texture...",
    bubble_activities: "Que suis-je autorise a faire dans ma bulle ?",
    bubble_activities_hint: "Lire, jouer calmement, dessiner, rever...",
    bubble_activities_ph: "Mes activites dans la bulle...",
    bubble_noise: "Niveau de bruit dans ma bulle",
    bubble_noise_silence: "silence",
    bubble_noise_low: "un peu",
    bubble_noise_medium: "moyen",
    bubble_signal: "Comment les adultes savent quand je demande une pause-bulle ?",
    bubble_signal_hint: "Mot code, carte, geste...",
    bubble_signal_ph: "Mon signal...",
    bubble_save: "Sauvegarder ma bulle",
    // Relaxation
    relax_steps_title: "Etapes de la relaxation",
    relax_after: "Apres l'exercice, je me sens...",
    relax_after_ph: "Plus calme, moins chaud, detendu...",
    relax_hands: "Mains",
    relax_arms: "Bras",
    relax_legs: "Jambes",
    relax_belly: "Ventre",
    relax_face: "Visage",
    relax_s1: "Je serre mes poings tres fort, comme si je voulais ecraser une orange. Je compte jusqu'a 5.",
    relax_s2: "Je relache doucement mes mains. Je sens la detente.",
    relax_s3: "Je tends mes bras tres fort, comme si je voulais toucher le plafond. Je compte jusqu'a 5.",
    relax_s4: "Je relache doucement mes bras. Je sens la detente.",
    relax_s5: "Je serre mes jambes tres fort. Je compte jusqu'a 5.",
    relax_s6: "Je relache mes jambes. Je sens la detente.",
    relax_s7: "Je serre mon ventre tres fort. Je compte jusqu'a 5.",
    relax_s8: "Je relache mon ventre. Je sens la detente.",
    relax_s9: "Je fais une grimace tres fort (visage serre). Je compte jusqu'a 5.",
    relax_s10: "Je relache mon visage. Je sens la detente.",
    // Agitation Radar
    radar_location: "Ou j'etais / Ce que je faisais",
    radar_location_ph: "A la maison, en classe...",
    radar_sensations: "Ce que j'ai ressenti dans mon corps",
    radar_sensations_ph: "Moteur qui vibre, jambes qui bougent, envie de parler, tete chaude...",
    radar_intensity: "Intensite (1 = un peu, 10 = tres fort)",
    radar_boredom: "Niveau d'ennui",
    radar_urge: "Envie de provoquer / faire des betises",
    radar_action: "Ce que j'ai fait",
    radar_action_ph: "J'ai utilise ma bulle, j'ai fait ma relaxation...",
    radar_after: "Comment je me suis senti apres ?",
    radar_after_ph: "Mieux, pareil, moins agite...",
    // Recharge
    recharge_what: "Qu'est-ce que j'ai fait ?",
    recharge_what_hint: "Lire, Lego, dessiner, calins, ne rien faire...",
    recharge_what_ph: "Mon activite calmante...",
    recharge_during: "Comment je me suis senti pendant ?",
    recharge_during_ph: "Calme, detendu, content...",
    recharge_after: "Comment je me suis senti apres ?",
    recharge_after_ph: "Recharge, pret a jouer, moins fatigue...",
    // Turbo Brain
    turbo_helps: "Mon turbo m'aide a...",
    turbo_brake: "Quand mon frein est fatigue...",
    turbo_preset_1: "Inventer des jeux",
    turbo_preset_2: "Repondre vite",
    turbo_preset_3: "Remarquer plein de choses",
    turbo_brake_1: "J'interromps les autres",
    turbo_brake_2: "Je fais des betises sans reflechir",
    turbo_brake_3: "Je me mets en colere d'un coup",
    // Mission
    mission_scenario: "La situation",
    mission_scenario_hint: "Ex: Maman se prepare, je suis en classe, on est au restaurant...",
    mission_scenario_ph: "Decris la situation...",
    mission_usual: "Ce que je fais d'habitude",
    mission_usual_ph: "Je parle, je touche a tout, je bouge...",
    mission_turbo: "Ce que mon cerveau turbo me dit",
    mission_turbo_ph: "Je m'ennuie, je veux parler tout de suite, et si je posais plein de questions...",
    mission_outcome: "Ce qui se passe apres (d'habitude)",
    mission_outcome_ph: "Maman est enervee, tout le monde est stresse...",
    mission_activity: "Ma mission : activite calme choisie",
    mission_activity_ph: "Dessin, BD, Lego, puzzle...",
    mission_result: "Resultat de la mission",
    mission_result_ph: "Comment ca s'est passe ? J'ai reussi ? C'etait difficile ?",
    mission_done: "Mission accomplie !",
    // Superhero Day
    day_energy: "Mon energie au fil de la journee",
    day_morning: "Matin maison",
    day_commute: "Trajet",
    day_class_am: "Classe matin",
    day_lunch: "Dejeuner",
    day_afternoon: "Apres-midi",
    day_sport: "Sport / Activite",
    day_evening: "Soir",
    day_bedtime: "Coucher",
    day_full: "Plein",
    day_medium: "Moyen",
    day_empty: "Vide",
    day_need_move: "bouger",
    day_need_talk: "parler",
    day_need_calm: "etre calme",
    day_need_hug: "calins",
    day_save: "Sauvegarder ma journee",
    // Victories
    victory_title: "Ma victoire",
    victory_examples: "Exemples : J'ai dormi sans me reveiller / J'ai pris le metro sans stress / J'ai mange tout mon repas / J'ai reussi a me calmer tout seul",
    victory_ph: "Aujourd'hui, j'ai reussi a...",
    victory_proud: "Je suis fier de moi parce que...",
    victory_proud_ph: "Parce que c'etait difficile et j'ai reussi...",
    victory_save: "Ajouter mon etoile !",
    // Questions
    questions_title: "Mes questions",
    questions_ph: "Question",
    questions_add: "Ajouter une question",
    questions_save: "Envoyer mes questions",
    // History labels
    hist_intensity: "Intensite",
    hist_periods: "periodes tracees",
  },
  es: {
    superpowers_title: "Mis Super-Poderes Cosmicos",
    superpowers_subtitle: "Descubre tus fuerzas secretas de astronauta!",
    safety_bubble_title: "Mi Burbuja Espacial",
    safety_bubble_subtitle: "Crea tu escudo de proteccion personalizado",
    relaxation_title: "Retorno a Orbita",
    relaxation_subtitle: "Relajacion muscular para vaciar tu motor",
    agitation_radar_title: "Mi Radar Galactico",
    agitation_radar_subtitle: "Detecta y comprende tus sensaciones",
    recharge_title: "Estacion de Recarga",
    recharge_subtitle: "Encuentra tus actividades para recargar baterias",
    turbo_brain_title: "Mi Nave Turbo",
    turbo_brain_subtitle: "Comprende tu cerebro turbo y su freno",
    mission_title: "Mision Espacial",
    mission_subtitle: "Supera desafios de autocontrol!",
    superhero_day_title: "Mi Dia de Astronauta",
    superhero_day_subtitle: "Sigue tu energia a lo largo del dia",
    victories_title: "Mis Estrellas de Victoria",
    victories_subtitle: "Celebra tus logros, incluso los mas pequenos!",
    therapist_questions_title: "Mensaje al Centro de Control",
    therapist_questions_subtitle: "Anota tus preguntas para tu terapeuta",
    save: "Guardar",
    add: "Agregar",
    other: "Otra cosa...",
    history: "Historial",
    no_history: "Sin historial",
    exercise_not_found: "Ejercicio no encontrado",
    saved_success: "Bravo, ejercicio guardado!",
    save_error: "Error al guardar",
    notes: "Notas",
    notes_placeholder: "Observaciones del dia...",
    sp_known: "Mis super-poderes que ya conozco",
    sp_custom: "Cuales son mis otros super-poderes?",
    sp_placeholder: "Super-poder",
    sp_save: "Guardar mis super-poderes",
    sp_preset_1: "Noto detalles que los demas no ven",
    sp_preset_2: "Tengo muchas ideas para jugar",
    sp_preset_3: "Entiendo a los demas cuando no estan bien",
    sp_preset_4: "Estoy muy concentrado cuando algo me apasiona",
    bubble_color: "De que color es mi burbuja?",
    bubble_color_hint: "Ej: azul tranquilo, verde relajante, rosa suave...",
    bubble_color_ph: "Color de mi burbuja...",
    bubble_shape: "Que forma tiene?",
    bubble_shape_hint: "Redonda, cuadrada, como un escudo...",
    bubble_shape_ph: "Forma...",
    bubble_texture: "Cual es su textura?",
    bubble_texture_hint: "Suave, solida, brillante...",
    bubble_texture_ph: "Textura...",
    bubble_activities: "Que puedo hacer dentro de mi burbuja?",
    bubble_activities_hint: "Leer, jugar tranquilo, dibujar, sonar...",
    bubble_activities_ph: "Mis actividades en la burbuja...",
    bubble_noise: "Nivel de ruido en mi burbuja",
    bubble_noise_silence: "silencio",
    bubble_noise_low: "un poco",
    bubble_noise_medium: "medio",
    bubble_signal: "Como saben los adultos cuando pido una pausa-burbuja?",
    bubble_signal_hint: "Palabra clave, tarjeta, gesto...",
    bubble_signal_ph: "Mi senal...",
    bubble_save: "Guardar mi burbuja",
    relax_steps_title: "Pasos de la relajacion",
    relax_after: "Despues del ejercicio, me siento...",
    relax_after_ph: "Mas tranquilo, menos caliente, relajado...",
    relax_hands: "Manos",
    relax_arms: "Brazos",
    relax_legs: "Piernas",
    relax_belly: "Barriga",
    relax_face: "Cara",
    relax_s1: "Aprieto mis punos muy fuerte, como si quisiera aplastar una naranja. Cuento hasta 5.",
    relax_s2: "Suelto suavemente mis manos. Siento la relajacion.",
    relax_s3: "Estiro mis brazos muy fuerte, como si quisiera tocar el techo. Cuento hasta 5.",
    relax_s4: "Suelto suavemente mis brazos. Siento la relajacion.",
    relax_s5: "Aprieto mis piernas muy fuerte. Cuento hasta 5.",
    relax_s6: "Suelto mis piernas. Siento la relajacion.",
    relax_s7: "Aprieto mi barriga muy fuerte. Cuento hasta 5.",
    relax_s8: "Suelto mi barriga. Siento la relajacion.",
    relax_s9: "Hago una mueca muy fuerte (cara apretada). Cuento hasta 5.",
    relax_s10: "Suelto mi cara. Siento la relajacion.",
    radar_location: "Donde estaba / Que hacia",
    radar_location_ph: "En casa, en clase...",
    radar_sensations: "Lo que senti en mi cuerpo",
    radar_sensations_ph: "Motor que vibra, piernas que se mueven, ganas de hablar, cabeza caliente...",
    radar_intensity: "Intensidad (1 = un poco, 10 = muy fuerte)",
    radar_boredom: "Nivel de aburrimiento",
    radar_urge: "Ganas de provocar / hacer travesuras",
    radar_action: "Lo que hice",
    radar_action_ph: "Use mi burbuja, hice mi relajacion...",
    radar_after: "Como me senti despues?",
    radar_after_ph: "Mejor, igual, menos agitado...",
    recharge_what: "Que hice?",
    recharge_what_hint: "Leer, Lego, dibujar, abrazos, no hacer nada...",
    recharge_what_ph: "Mi actividad calmante...",
    recharge_during: "Como me senti durante?",
    recharge_during_ph: "Tranquilo, relajado, contento...",
    recharge_after: "Como me senti despues?",
    recharge_after_ph: "Recargado, listo para jugar, menos cansado...",
    turbo_helps: "Mi turbo me ayuda a...",
    turbo_brake: "Cuando mi freno esta cansado...",
    turbo_preset_1: "Inventar juegos",
    turbo_preset_2: "Responder rapido",
    turbo_preset_3: "Notar muchas cosas",
    turbo_brake_1: "Interrumpo a los demas",
    turbo_brake_2: "Hago travesuras sin pensar",
    turbo_brake_3: "Me enojo de repente",
    mission_scenario: "La situacion",
    mission_scenario_hint: "Ej: Mama se prepara, estoy en clase, estamos en el restaurante...",
    mission_scenario_ph: "Describe la situacion...",
    mission_usual: "Lo que hago normalmente",
    mission_usual_ph: "Hablo, toco todo, me muevo...",
    mission_turbo: "Lo que mi cerebro turbo me dice",
    mission_turbo_ph: "Me aburro, quiero hablar ya, y si hago muchas preguntas...",
    mission_outcome: "Lo que pasa despues (normalmente)",
    mission_outcome_ph: "Mama se enoja, todos estan estresados...",
    mission_activity: "Mi mision: actividad tranquila elegida",
    mission_activity_ph: "Dibujo, comic, Lego, rompecabezas...",
    mission_result: "Resultado de la mision",
    mission_result_ph: "Como fue? Lo logre? Fue dificil?",
    mission_done: "Mision cumplida!",
    day_energy: "Mi energia a lo largo del dia",
    day_morning: "Manana en casa",
    day_commute: "Camino",
    day_class_am: "Clase manana",
    day_lunch: "Almuerzo",
    day_afternoon: "Tarde",
    day_sport: "Deporte / Actividad",
    day_evening: "Noche",
    day_bedtime: "Hora de dormir",
    day_full: "Lleno",
    day_medium: "Medio",
    day_empty: "Vacio",
    day_need_move: "moverme",
    day_need_talk: "hablar",
    day_need_calm: "estar tranquilo",
    day_need_hug: "abrazos",
    day_save: "Guardar mi dia",
    victory_title: "Mi victoria",
    victory_examples: "Ejemplos: Dormi sin despertarme / Tome el metro sin estres / Comi toda mi comida / Logre calmarme solo",
    victory_ph: "Hoy logre...",
    victory_proud: "Estoy orgulloso de mi porque...",
    victory_proud_ph: "Porque era dificil y lo logre...",
    victory_save: "Agregar mi estrella!",
    questions_title: "Mis preguntas",
    questions_ph: "Pregunta",
    questions_add: "Agregar una pregunta",
    questions_save: "Enviar mis preguntas",
    hist_intensity: "Intensidad",
    hist_periods: "periodos registrados",
  },
  en: {
    superpowers_title: "My Cosmic Super-Powers",
    superpowers_subtitle: "Discover your secret astronaut strengths!",
    safety_bubble_title: "My Space Bubble",
    safety_bubble_subtitle: "Create your personalized protection shield",
    relaxation_title: "Return to Orbit",
    relaxation_subtitle: "Muscle relaxation to empty your engine",
    agitation_radar_title: "My Galactic Radar",
    agitation_radar_subtitle: "Detect and understand your sensations",
    recharge_title: "Recharge Station",
    recharge_subtitle: "Find your activities to recharge your batteries",
    turbo_brain_title: "My Turbo Ship",
    turbo_brain_subtitle: "Understand your turbo brain and its brake",
    mission_title: "Space Mission",
    mission_subtitle: "Take on self-control challenges!",
    superhero_day_title: "My Astronaut Day",
    superhero_day_subtitle: "Track your energy throughout the day",
    victories_title: "My Victory Stars",
    victories_subtitle: "Celebrate your achievements, even the smallest!",
    therapist_questions_title: "Message to Mission Control",
    therapist_questions_subtitle: "Write down your questions for your therapist",
    save: "Save",
    add: "Add",
    other: "Something else...",
    history: "History",
    no_history: "No history yet",
    exercise_not_found: "Exercise not found",
    saved_success: "Great job, exercise saved!",
    save_error: "Error saving",
    notes: "Notes",
    notes_placeholder: "Day observations...",
    sp_known: "My super-powers I already know",
    sp_custom: "What are my other super-powers?",
    sp_placeholder: "Super-power",
    sp_save: "Save my super-powers",
    sp_preset_1: "I notice details others don't see",
    sp_preset_2: "I have lots of ideas for playing",
    sp_preset_3: "I understand others when they're not feeling well",
    sp_preset_4: "I'm super focused when I'm passionate about something",
    bubble_color: "What color is my bubble?",
    bubble_color_hint: "E.g.: calm blue, soothing green, soft pink...",
    bubble_color_ph: "My bubble's color...",
    bubble_shape: "What shape is it?",
    bubble_shape_hint: "Round, square, like a shield...",
    bubble_shape_ph: "Shape...",
    bubble_texture: "What is its texture?",
    bubble_texture_hint: "Soft, solid, shiny...",
    bubble_texture_ph: "Texture...",
    bubble_activities: "What am I allowed to do in my bubble?",
    bubble_activities_hint: "Read, play quietly, draw, dream...",
    bubble_activities_ph: "My activities in the bubble...",
    bubble_noise: "Noise level in my bubble",
    bubble_noise_silence: "silence",
    bubble_noise_low: "a little",
    bubble_noise_medium: "medium",
    bubble_signal: "How do adults know when I ask for a bubble-break?",
    bubble_signal_hint: "Code word, card, gesture...",
    bubble_signal_ph: "My signal...",
    bubble_save: "Save my bubble",
    relax_steps_title: "Relaxation steps",
    relax_after: "After the exercise, I feel...",
    relax_after_ph: "Calmer, less hot, relaxed...",
    relax_hands: "Hands",
    relax_arms: "Arms",
    relax_legs: "Legs",
    relax_belly: "Belly",
    relax_face: "Face",
    relax_s1: "I squeeze my fists very tight, like I want to crush an orange. I count to 5.",
    relax_s2: "I gently release my hands. I feel the relaxation.",
    relax_s3: "I stretch my arms very tight, like I want to touch the ceiling. I count to 5.",
    relax_s4: "I gently release my arms. I feel the relaxation.",
    relax_s5: "I squeeze my legs very tight. I count to 5.",
    relax_s6: "I release my legs. I feel the relaxation.",
    relax_s7: "I squeeze my belly very tight. I count to 5.",
    relax_s8: "I release my belly. I feel the relaxation.",
    relax_s9: "I make a very big grimace (tight face). I count to 5.",
    relax_s10: "I release my face. I feel the relaxation.",
    radar_location: "Where I was / What I was doing",
    radar_location_ph: "At home, in class...",
    radar_sensations: "What I felt in my body",
    radar_sensations_ph: "Engine vibrating, legs moving, wanting to talk, hot head...",
    radar_intensity: "Intensity (1 = a little, 10 = very strong)",
    radar_boredom: "Boredom level",
    radar_urge: "Urge to provoke / do silly things",
    radar_action: "What I did",
    radar_action_ph: "I used my bubble, I did my relaxation...",
    radar_after: "How did I feel after?",
    radar_after_ph: "Better, the same, less agitated...",
    recharge_what: "What did I do?",
    recharge_what_hint: "Read, Lego, draw, cuddles, nothing...",
    recharge_what_ph: "My calming activity...",
    recharge_during: "How did I feel during?",
    recharge_during_ph: "Calm, relaxed, happy...",
    recharge_after: "How did I feel after?",
    recharge_after_ph: "Recharged, ready to play, less tired...",
    turbo_helps: "My turbo helps me to...",
    turbo_brake: "When my brake is tired...",
    turbo_preset_1: "Invent games",
    turbo_preset_2: "Answer quickly",
    turbo_preset_3: "Notice lots of things",
    turbo_brake_1: "I interrupt others",
    turbo_brake_2: "I do silly things without thinking",
    turbo_brake_3: "I get angry all of a sudden",
    mission_scenario: "The situation",
    mission_scenario_hint: "E.g.: Mom is getting ready, I'm in class, we're at the restaurant...",
    mission_scenario_ph: "Describe the situation...",
    mission_usual: "What I usually do",
    mission_usual_ph: "I talk, I touch everything, I move...",
    mission_turbo: "What my turbo brain tells me",
    mission_turbo_ph: "I'm bored, I want to talk right now, what if I ask lots of questions...",
    mission_outcome: "What happens after (usually)",
    mission_outcome_ph: "Mom gets angry, everyone is stressed...",
    mission_activity: "My mission: chosen calm activity",
    mission_activity_ph: "Drawing, comics, Lego, puzzle...",
    mission_result: "Mission result",
    mission_result_ph: "How did it go? Did I succeed? Was it hard?",
    mission_done: "Mission accomplished!",
    day_energy: "My energy throughout the day",
    day_morning: "Morning home",
    day_commute: "Commute",
    day_class_am: "Morning class",
    day_lunch: "Lunch",
    day_afternoon: "Afternoon",
    day_sport: "Sport / Activity",
    day_evening: "Evening",
    day_bedtime: "Bedtime",
    day_full: "Full",
    day_medium: "Medium",
    day_empty: "Empty",
    day_need_move: "move",
    day_need_talk: "talk",
    day_need_calm: "be calm",
    day_need_hug: "cuddles",
    day_save: "Save my day",
    victory_title: "My victory",
    victory_examples: "Examples: I slept without waking up / I took the subway without stress / I ate all my meal / I managed to calm down by myself",
    victory_ph: "Today, I managed to...",
    victory_proud: "I'm proud of myself because...",
    victory_proud_ph: "Because it was hard and I succeeded...",
    victory_save: "Add my star!",
    questions_title: "My questions",
    questions_ph: "Question",
    questions_add: "Add a question",
    questions_save: "Send my questions",
    hist_intensity: "Intensity",
    hist_periods: "periods tracked",
  },
};

Object.assign(tdahKidsTranslations, extra);

export const useTdahKidsI18n = (locale) => {
  const lang = locale && tdahKidsTranslations[locale] ? locale : "fr";
  return tdahKidsTranslations[lang];
};

export default tdahKidsTranslations;
